import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { useCQuery } from '../../../../Services/QueryCache'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, Modal, Spinner, Text } from '../../../../Components'
import { Column } from 'primereact/column'
import { deleteTraveller } from '../Editor/Functions'
import { columnProps } from '../../../../Services/Functions'

export function TravellersList () {
  const { data: travellers = [], isSuccess } = useCQuery(['travellers'])
  const [travellersTable, setTravellersTable] = useState([])
  const navigate = useNavigate([])

  useEffect(() => {
    setTravellersTable(travellers.map((r) => r))
  }, [travellers])

  const BtnActions = ({ id }) => {
    const [modalVisible, setModalVisible] = useState(false)
    return (
      <Flex width={160} row>
        <Modal visible={modalVisible} header='Cancellazione Viaggiatore' onHide={() => setModalVisible(false)}>
          <Flex fw>
            <Text value='Vuoi cancellare questo viaggiatore?' />
            <Flex fw row jb style={{ marginTop: 20 }}>
              <Button label='Annulla' icon='fa-duotone fa-trash' onClick={() => setModalVisible(false)} />
              <Button label='Conferma' icon='fa-duotone fa-check' onClick={() => deleteTraveller(id)} />
            </Flex>
          </Flex>
        </Modal>
        <Button round tooltip='Modifica' icon='fa-duotone fa-pen' onClick={() => navigate('/admin/travellers/' + id)} />
        <Button style={{ marginLeft: 20 }} round tooltip='Elimina' icon='fa-duotone fa-trash' onClick={() => setModalVisible(true)} />
      </Flex>
    )
  }

  if (!isSuccess) return <Spinner />
  return (
    <Flex fw fh js>
      <Flex fw row je ae>
        <Button label='Importa viaggiatori' icon='fa-duotone fa-plus' style={{ marginRight: 10 }} onClick={() => navigate('/admin/travellers/import')} />
        <Button label='Crea Nuovo' icon='fa-duotone fa-plus' style={{ marginRight: 10 }} onClick={() => navigate('/admin/travellers/new')} />
      </Flex>
      <Text value='Lista Viaggiatori' size={20} bold />
      <DataTable
        style={{ width: '100%' }} filterDisplay='row' sortField='createdAt' sortOrder={-1} className='TableSignatures'
        value={travellersTable} emptyMessage='Nessun viaggiatore trovato' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='pid' {...columnProps('PID')} />
        <Column field='email' {...columnProps('Email')} />
        <Column field='phone' {...columnProps('Telefono')} />
        <Column field='client.name' {...columnProps('Cliente')} />
        <Column field='createdAt' {...columnProps('Data creazione')} body={({ createdAt }) => new Date(createdAt).toLocaleDateString()} />
        <Column style={{ border: 'none', width: 140, height: 15, textAlign: 'center' }} body={(props) => <BtnActions {...props} />} />
      </DataTable>
    </Flex>
  )
}
